module.exports = __webpack_public_path__ + "img/14.00ee90fe.jpg";